/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * This signifies what the number in the \'amount\' field is.
 * @export
 * @enum {string}
 */
export enum AmountUnit {
    FIAT = 'FIAT',
    VARIABLE = 'VARIABLE',
    FIXED = 'FIXED'
}

export function AmountUnitFromJSON(json: any): AmountUnit {
    return AmountUnitFromJSONTyped(json, false);
}

export function AmountUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): AmountUnit {
    return json as AmountUnit;
}

export function AmountUnitToJSON(value?: AmountUnit | null): any {
    return value as any;
}

